export const IMAGE_SCALES = ['auto', 'xl', 'lar', 'med', 'sml', 'xsml'];
